/** The professional's profile totals the detail pages state beside the trail. */
export interface DetailItemStats {
    views: number;
    saves: number;
}

/** The aggregated public KPI selection the three pages' professional queries share. */
export interface DetailProfileKpi {
    TotalPageViews?: number | null;
    TotalImpressions?: number | null;
    TotalSaves?: number | null;
}

/**
 * Views are page views plus impressions, as the professional page counts
 * them, so the figure here never disagrees with the profile it belongs to.
 */
export const detailStatsFromProfileKpi = (
    kpi?: DetailProfileKpi | null,
): DetailItemStats | undefined => {
    if (!kpi) return undefined;
    return {
        views: (kpi.TotalPageViews ?? 0) + (kpi.TotalImpressions ?? 0),
        saves: kpi.TotalSaves ?? 0,
    };
};

/** One trust-row figure: the shortened count and the word it is counting. */
export type DetailStatPart = readonly [count: string, label: string];

/**
 * The trust rows' worded figures — "1.5M views · 233 saves" — in the order
 * they are read. A figure of nought is dropped rather than shown: a practice
 * with no saves yet should not be made to say so under its own name.
 */
export const detailStatParts = (
    stats: DetailItemStats | undefined,
    shorten: (value: number) => string,
): DetailStatPart[] => {
    if (!stats) return [];
    const parts: DetailStatPart[] = [];
    if (stats.views > 0) parts.push([shorten(stats.views), 'views']);
    if (stats.saves > 0) parts.push([shorten(stats.saves), 'saves']);
    return parts;
};
